// ─── Tenant Provisioning Contracts ───────────────────────────────
// Zod schemas + TypeScript types for provisionNewTenant().
import { z } from 'zod';
// ─── DB Target Enum ──────────────────────────────────────────────
export const dbTargetSchema = z.enum(['supabase', 'neon', 'planetscale', 'none']);
// ─── Options ─────────────────────────────────────────────────────
export const provisionTenantOptionsSchema = z.object({
    /** Slug-style name, e.g. "warmgraph" — used as profile_name and repo_name */
    name: z
        .string()
        .min(2)
        .max(50)
        .regex(/^[a-z0-9][a-z0-9-]*[a-z0-9]$/, 'name must be a lowercase slug'),
    /** GitHub repo slug, e.g. "warmgraph" (owner defaults to lumeniqjs) */
    github_repo: z
        .string()
        .min(1)
        .max(100)
        .regex(/^[a-zA-Z0-9_.-]+$/, 'github_repo must be a valid repo name'),
    /** Which DB backend to associate with this tenant */
    db_target: dbTargetSchema,
});
// ─── Completed Steps ─────────────────────────────────────────────
export const provisionStepSchema = z.enum(['profile', 'repo', 'docs', 'smoke']);
// ─── Result ──────────────────────────────────────────────────────
export const provisionTenantResultSchema = z.object({
    status: z.enum(['completed', 'partial', 'failed']),
    profile_name: z.string(),
    github_repo_url: z.string(),
    db_target_id: z.string().nullable(),
    smoke_fire_id: z.string().nullable(),
    failure_reason: z.string().optional(),
    steps_completed: z.array(provisionStepSchema),
});
//# sourceMappingURL=provisioning.js.map